/*eslint-disable no-unreachable */
import React from 'react'
import { Modal, Popup, Form, Input, Label, Header, Button, Icon } from 'semantic-ui-react'
import {connect} from 'react-redux'
var moment = require('moment');
require('moment/locale/de');
import {bg as colors, fg as fgColors} from '../../constants/ScheduleColors';

function mapStateToProps (state) {
   return {}
}

export class TrackIndex extends React.Component {
	render() {
		return (
			<div style={{
				width: '100%',
				height: '100%',
				textAlign: 'center',
				lineHeight: '32px',
				verticalAlign: 'middle',
				backgroundColor: '#555555',
				color: '#FFFFFF'
			}}>{this.props.children}</div>	
		)

	}
}

export class TrackItem extends React.Component {	
	getPosition(){
		
		let start = this.props.item.start;
		let end = this.props.item.end;
		
		if(typeof this.props.item.deleted !== 'undefined' && this.props.item.deleted)return null;
		
		if(typeof this.props.item.preview !== 'undefined' && this.props.item.preview !== null){
			if(typeof this.props.item.preview.start !== 'undefined' && this.props.item.preview.start !== null)
				start = this.props.item.preview.start;
			if(typeof this.props.item.preview.end !== 'undefined' && this.props.item.preview.end !== null)
				end = this.props.item.preview.end;
			if(typeof this.props.item.preview.deleted !== 'undefined' && this.props.item.preview.deleted)
				return null;
		}
		
		var left = (100 / this.props.timespan.seconds * (start - this.props.timespan.start)) + '%';
		var right = (100 / this.props.timespan.seconds * (this.props.timespan.end - end)) + '%';
		
		return {
			left: left,
			right: right
		}
	}
	
	getDragOffsets(e){
		var target = e.target;
		
		while(!target.classList.contains('trackitem'))
			target = target.parentNode;
		
		var offset = 0;
		var offsetTarget = target;
		
		while(typeof offsetTarget.offsetParent !== 'undefined' && offsetTarget.offsetParent !== null){
			offset += offsetTarget.offsetLeft;
			offsetTarget = offsetTarget.offsetParent;
		}
		
		var factor = 1 / target.offsetWidth * (e.clientX - offset);
		
		let seconds = this.props.item.end - this.props.item.start;
		let offsetStart = Math.round(seconds * factor) * -1;
		let offsetEnd = seconds + offsetStart;
		
		return {
			'offsetStart': offsetStart,
			'offsetEnd': offsetEnd
		};
	}
	
	selectItem(e){
		e.stopPropagation();
		e.preventDefault();
		this.props.onSelect(this.props.item.index);	
	}
	
	removeItem(e){
		e.stopPropagation();
		e.preventDefault();
		this.props.onRemove(this.props.item.index);	
	}
	
	unselectItem(e){
		e.stopPropagation();
		e.preventDefault();
		this.props.onSelect(null);	
	}
	
	render() {
		var pos = this.getPosition();
		
		if(pos === null)
			return null;
		
		//const colors = ['#990033', '#a477c4', '#3498db', '#1abc9c','#55e08f','#fff054','#ef5523','#fe374a','#baa891','#ad5f43'];
		//const fgColors = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#000000','#000000','#000000','#FFFFFF','#FFFFFF','#000000','#FFFFFF'];
		
		let top = '2px';

		if(this.props.corresponding){
			top = 0;
			
			if(this.props.item.lotteryId === null && this.props.item.channelId === null){
				top += 22;	
			}else if(this.props.item.lotteryId === null){
				top += 11;	
			}
			
			top += 'px';
		}
        
        const meta = {
            ...this.props.metaitem,
            ...this.props.item.meta
        };
		
		return (
			<div style={{
				position: 'absolute',
				backgroundColor: meta.backgroundColor || (typeof meta.coloridx !== 'undefined')?colors[meta.coloridx % colors.length]:colors[this.props.item.index % colors.length],
				color: meta.color || (typeof meta.coloridx !== 'undefined')?fgColors[meta.coloridx % colors.length]:fgColors[this.props.item.index % fgColors.length],
				borderRadius: '5px',
				left: pos.left,
				right: pos.right,
				top: top,
				height: (this.props.corresponding)?'11px':'27px',
				fontSize: (this.props.corresponding)?'70%':'100%',
				lineHeight: (this.props.corresponding)?'5px':'normal',
				opacity: (this.props.corresponding)?'0.6':1,
				display: 'flex',
				boxShadow: (this.props.selected)?'2px 2px 3px #555555':''
			}} className="trackitem" onClick={(e) => this.selectItem(e)}>
			{
				(this.props.selected)?
					<div style={{
						position: 'absolute',
						top: '32px',
						zIndex: 5
					}}>
						<div style={{
							    top: 'auto',
							    right: 'auto',
							    top: '-.30714286em',
							    left: '50%',
							    marginLeft: '-.30714286em',
							    background: '#FFFFFF',
							    position: 'absolute',
							    width: '.71428571em',
							    height: '.71428571em',
							    transform: 'rotate(45deg)',
							    boxShadow: '-1px -1px 0 0 #bababc',
							    zIndex: 10
							}}>
							
						</div>
						<div style={{
							position: 'relative',
							color: '#000000',
							border: '1px solid #d4d4d5',
							background: '#fff',
							boxShadow: '0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15)',
							borderRadius: '3px',
							padding: '.833em 1em'
						}}>
							
							<Button onClick={(e) => this.unselectItem(e)}>Abbruch</Button>
							<Button color="red" onClick={(e) => this.removeItem(e)}>Löschen</Button>
						</div>
					</div>
          		:null
			}
			
			
				{
					(this.props.corresponding)?
						null
					:
						<div draggable onDragStart={(e) => this.props.onDragStart(e, 'resize-before', this.props.item)} onDragEnd={(e) => this.props.onDragEnd(e, 'resize-before', this.props.item)} style={{
							width: '10px',
							minWidth: '10px',
							borderRight: '1px dotted ' + this.props.item.meta.color || fgColors[this.props.item.index % fgColors.length],
							cursor: 'resize-w',
							flexGrow: 0
						}}></div>
				}
				
				<div draggable  
					onDragStart={(e) => {if(!this.props.corresponding)this.props.onDragStart(e, 'move', this.props.item, this.getDragOffsets(e))}}
					onDragEnd={(e) => {if(!this.props.corresponding)this.props.onDragEnd(e, 'move', this.props.item)}} 
					style={{
						height: '100%',
						pointerEvents: (this.props.corresponding)?'none':'inherit',
						
						cursor: 'resize-e',
						flexGrow: 1,
						padding: '1px 2px 3px 2px',
						textAlign: 'center',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap'
					}}>
					<div>{meta.name}</div>
                    <div style={{
                        fontSize: '70%',
                        position: 'relative',
                        top: '-3px',
                        display: 'flex'
                    }}>
                        <div style={{
                            flexGrow: 1,
                            textAlign: 'left'
                        }}>{moment(this.props.item.start * 1000).format('dd., HH:mm')}</div>
                        <div style={{
                            flexGrow: 1,
                            textAlign: 'right'
                        }}>{moment(this.props.item.end * 1000).format('dd., HH:mm')}</div>
                    </div>
				</div>
				
				{
					(this.props.corresponding)?
						null
					:
						<div draggable  onDragStart={(e) => this.props.onDragStart(e, 'resize-after', this.props.item)} onDragEnd={(e) => this.props.onDragEnd(e, 'resize-after', this.props.item)} style={{
							width: '10px',
							minWidth: '10px',
							borderLeft: '1px dotted ' + this.props.item.meta.color || fgColors[this.props.item.index % fgColors.length],
							cursor: 'resize-e',
							flexGrow: 0
						}}></div>
				}
			</div>
		)

	}
}

class TrackComponent extends React.Component {
	getDragPosition(e){
		var target = e.target;
		
		while(!target.classList.contains('track'))
			target = target.parentNode;
		
		var offset = 0;
		var offsetTarget = target;
		
		while(typeof offsetTarget.offsetParent !== 'undefined' && offsetTarget.offsetParent !== null){
			offset += offsetTarget.offsetLeft;
			offsetTarget = offsetTarget.offsetParent;
		}
		
		return 1 / target.offsetWidth * (e.clientX - offset);
	}
	
	render() {
		return (
			<div style={{
				height: '60px',
				backgroundColor: '#FFFFFF',
				display: 'flex',
				height: (this.props.corresponding !== null && this.props.corresponding.length > 0)?'66px':'32px'
			}}>
				<div style={{
					flexGrow: 0,
					width: this.props['width-before']
				}}>{
					(this.props.before)?
						this.props.before
					:null
				}</div>
				<div style={{
					borderLeft: '1px solid #CCCCCC',
					borderRight: '1px solid #CCCCCC',
					borderBottom: '1px solid #CCCCCC',
					flexGrow: 1,
					position: 'relative'
				}} onMouseUp={(e) => this.props.onDragEnd(e)} onClick={(e) => this.props.onCreate(this.getDragPosition(e), this.props.track)} className='track' onDragOver={(e) => this.props.onDragOver(e, this.getDragPosition(e), this.props.track)} onMouseMove={(e) => this.props.onDragOver(e, this.getDragPosition(e), this.props.track)}>
				{
                    (this.props.items)?
                        this.props.items.map((item, idx) => (
                            <TrackItem metaitem={(typeof this.props.metaitems !== 'undefined' && this.props.metaitems !== null && typeof this.props.metaitems[item.meta.id] !== 'undefined')?this.props.metaitems[item.meta.id]:null} selected={this.props.selectedItem !== null && this.props.selectedItem === item.index} key={idx} onSelect={(itemIndex) => this.props.onSelect(itemIndex, this.props.track)} onRemove={(itemIndex) => this.props.onRemove(itemIndex, this.props.track)} onDragStart={this.props.onDragStart} onDragEnd={this.props.onDragEnd} timespan={this.props.timespan} item={item}/>
                        ))
                    :null
				}
					<div style={{
						position: 'absolute',
						left: 0,
						top: '32px',
						bottom: 0,
						right: 0,
						borderTop: '1px dotted #CCCCCC',
						backgroundColor: '#eeeeee'
					}}>
					{
						(this.props.corresponding === null)?
							null
						:
							this.props.corresponding.map((item, idx) => (
								<TrackItem corresponding key={'corresponding_' + idx} timespan={this.props.timespan} item={item}/>
							))	
					}
					</div>
				</div>
				<div style={{
					flexGrow: 0,
					width: this.props['width-after']
				}}></div>
			</div>
		)
	}
};

export const Track = connect(
  mapStateToProps
)(TrackComponent)